import { PxdAgEditGridDefaultColumnDef, PxdAgGridColumnTypes, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions } from "@app/shared/aggrid/pxd-ag-grid-options";

export const ProjectScopingCapacitiesGridOptions: PxdAgGridOptions = {
  enableCharts: true,
  cellSelection: true,
  rowGroupPanelShow: 'never',
  defaultColDef: PxdAgEditGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  groupDisplayType: 'groupRows',
  headerHeight: 50,
  suppressAggFuncInHeader: true,
  aggFuncs: {
    'CategoryCapacity': params => {
      let totalCapacity = 0;
      let existingCapacity = 0;
      let totalCapacities: number[] = [];
      let existingCapacities: number[] = [];

      for (let i = 0; i < params.rowNode.allLeafChildren.length; i++) {
        const element = params.rowNode.allLeafChildren[i];
        if (!element.data.ExcludeFromOverallCapacityCalculation) {
          totalCapacities.push(element.data.TotalCapacity);
          existingCapacities.push(element.data.ExistingCapacity);
        }
      }

      if (totalCapacities.length > 0) {
        let minValue = Math.min.apply(null, totalCapacities.filter(Number));
        totalCapacity = minValue != Infinity ? minValue : 0;
      }

      if (existingCapacities.length > 0) {
        let minValue = Math.min.apply(null, existingCapacities.filter(Number));
        existingCapacity = minValue != Infinity ? minValue : 0;
      }

      return totalCapacity - existingCapacity;
    },
    'ForecastAmount': params => {
      let val = 0;

      for (let i = 0; i < params.rowNode.allLeafChildren.length; i++) {
        const element = params.rowNode.allLeafChildren[i];

        if (element.data.ForecastAmount && element.data.ForecastAmount !== 0) {
          val = element.data.ForecastAmount.toLocaleString();
          break;
        }
      }

      return val;
    }
    , 'CategoryExistingCapacity': params => {
      let categoryExistingCapacity = 0;
      let values: number[] = [];

      for (let i = 0; i < params.rowNode.allLeafChildren.length; i++) {
        const element = params.rowNode.allLeafChildren[i];
        if (!element.data.ExcludeFromOverallCapacityCalculation) {
          values.push(element.data.ExistingCapacity);
        }
      }

      if (values.length > 0) {
        let minValue = Math.min.apply(null, values.filter(Number));
        if (minValue != Infinity) {
          categoryExistingCapacity = minValue
        }
      }
      return categoryExistingCapacity;
    }
    , 'CategoryTotalCapacity': params => {
      let categoryTotalCapacity = 0;
      let values: number[] = [];

      for (let i = 0; i < params.rowNode.allLeafChildren.length; i++) {
        const element = params.rowNode.allLeafChildren[i];
        if (!element.data.ExcludeFromOverallCapacityCalculation) {
          values.push(element.data.TotalCapacity);
        }
      }

      if (values.length > 0) {
        let minValue = Math.min.apply(null, values.filter(Number));
        if (minValue != Infinity) {
          categoryTotalCapacity = minValue
        }
      }
      return categoryTotalCapacity;
    }
  },
  autoGroupColumnDef: {
    width: 175,
    headerName: 'Category',
    suppressSizeToFit: true,
    cellRendererParams: {
      suppressCount: true
    }
  },
  columnDefs: [
    { field: 'CapacitySubCategoryId', hide: true, enableRowGroup: false },
    { field: 'CapacityCategoryDto.Description', rowGroup: true, hide: true },
    { field: 'Description', headerName: 'Sub Category', editable: false },
    { field: 'ExistingCapacity', editable: false, enableRowGroup: false, type: 'numericColumn', aggFunc: 'CategoryExistingCapacity', valueFormatter: params => params.value.toLocaleString() },
    { field: 'ProposedCapacity', editable: false, enableRowGroup: false, type: 'numericColumn', aggFunc: 'CategoryCapacity', valueFormatter: params => params.value.toLocaleString() },
    { field: 'TotalCapacity', editable: false, enableRowGroup: false, type: 'numericColumn', aggFunc: 'CategoryTotalCapacity', valueFormatter: params => params.value.toLocaleString() },
    { field: 'ForecastAmount', headerName: 'Forecast', editable: false, enableRowGroup: false, type: 'numericColumn', aggFunc: 'ForecastAmount', valueFormatter: params => params.value.toLocaleString() }
  ]
}